const NOTIFICATION_ROOT_ID = "notification-root"
const SIDE_MENU_ID = "side-menu"
const APPS_WITHOUT_ADDITIONAL_CONTAINERS: ReadonlyArray<string> = [
  "flow_builder",
  "login",
  "two-factor-auth-new",
  "agent-workspace"
]

const APPS_WITH_OWN_NOTIFICATION_ROOT: ReadonlyArray<string> = ["agent-workspace"]
const FLEX_CONTAINER_APPS: ReadonlyArray<string> = ["metrics"]
const MAX_CONTAINER_CLASS = "max-1024"
const ADMIN_CONTAINER_CLASS = "admin-container"
const FLEX_CONTAINER_CLASS = "flex-container"
const SCAFFOLD_IDS = new Set([NOTIFICATION_ROOT_ID, SIDE_MENU_ID])

type MountLayoutOptions = {
  adminAppKeys: ReadonlyArray<string>
}

const resolveContainerClass = (adminAppKeys: ReadonlyArray<string>): string => {
  if (FLEX_CONTAINER_APPS.some((key) => document.querySelector(`[data-app="${key}"]`))) {
    return FLEX_CONTAINER_CLASS
  }

  if (adminAppKeys.some((key) => document.querySelector(`[data-app="${key}"]`))) {
    return ADMIN_CONTAINER_CLASS
  }

  return MAX_CONTAINER_CLASS
}

const ensureContentContainer = (adminAppKeys: ReadonlyArray<string>): HTMLElement => {
  const existing = document.querySelector<HTMLElement>(
    `.${MAX_CONTAINER_CLASS}, .${ADMIN_CONTAINER_CLASS}, .${FLEX_CONTAINER_CLASS}`
  )

  if (existing) {
    return existing
  }

  const wrapper = document.createElement("div")

  wrapper.className = resolveContainerClass(adminAppKeys)

  Array.from(document.body.children).forEach((child) => {
    if (SCAFFOLD_IDS.has(child.id)) {
      return
    }
    if (child.tagName === "SCRIPT" || child.tagName === "STYLE") {
      return
    }

    wrapper.appendChild(child)
  })

  document.body.appendChild(wrapper)

  return wrapper
}

const ensureScaffoldDiv = (id: string, anchor: Element): HTMLElement => {
  const existing = document.getElementById(id)

  if (existing) {
    return existing
  }

  const el = document.createElement("div")

  el.id = id
  anchor.before(el)

  return el
}

const findFullViewportApp = (): Element | null => {
  for (const id of APPS_WITHOUT_ADDITIONAL_CONTAINERS) {
    const el = document.querySelector(`[data-app="${id}"]`)

    if (el) {
      return el
    }
  }

  return null
}

const hasOwnNotificationRoot = (): boolean =>
  APPS_WITH_OWN_NOTIFICATION_ROOT.some((id) => document.querySelector(`[data-app="${id}"]`))

export const mountLayout = ({ adminAppKeys }: MountLayoutOptions): void => {
  const fullViewportApp = findFullViewportApp()

  if (fullViewportApp) {
    if (!hasOwnNotificationRoot()) {
      ensureScaffoldDiv(NOTIFICATION_ROOT_ID, fullViewportApp)
    }

    return
  }

  const contentContainer = ensureContentContainer(adminAppKeys)
  const sideMenu = ensureScaffoldDiv(SIDE_MENU_ID, contentContainer)

  ensureScaffoldDiv(NOTIFICATION_ROOT_ID, sideMenu)
}
